import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import client from '@/store/client';

const actionMap = {
  is_login: '打开网页来完成登录操作',
  is_verify: '打开网页来完成检验操作',
}

const McpToolsBUAction = observer((props) => {
  const {
    className = '',
    event,
  } = props;

  // 登录成功，不再显示
  if (event?.status === 'success') {
    return null;
  }

  return (
    <div className={`flex w-8/10 h-52px rounded-12px items-center border-1px border-black border-opacity-10 ${className}`} data-id={event.planStepId}>
      <img src="https://p1.ssl.qhimg.com/t11098f6bcd10e4774659178213.png" alt="" className="size-20px ml-12px" />
      <div className="text-14px leading-20px text-black ml-10px w-0 flex-grow truncate">
        { actionMap[event?.buResult?.action] || event.title || event.description}
      </div>
      <div 
        className="w-60px h-28px rounded-full flex items-center justify-center text-white mr-12px text-12px bg-black cursor-pointer"
        onClick={
          () => {
            client.run("BrowserRestore", null, "1");
          }
        }>
        打开
      </div>
    </div>
  )
});
export default McpToolsBUAction;